import { useState, useCallback } from 'react';
import { format } from 'date-fns';

export const useFormCita = () => {
  const [formData, setFormData] = useState({
    cliente_id: '',
    servicio_id: '',
    fecha_cita: format(new Date(), 'yyyy-MM-dd'),
    hora_inicio: '09:00',
    notas: ''
  });

  const [errores, setErrores] = useState({});

  // Validar formulario
  const validar = useCallback((data, servicios) => {
    const nuevosErrores = {};

    if (!data.cliente_id) {
      nuevosErrores.cliente_id = 'Selecciona un cliente';
    }

    if (!data.servicio_id) {
      nuevosErrores.servicio_id = 'Selecciona un servicio';
    }

    if (!data.fecha_cita) {
      nuevosErrores.fecha_cita = 'Selecciona una fecha';
    }

    if (!data.hora_inicio) {
      nuevosErrores.hora_inicio = 'Selecciona una hora';
    }

    // Validar fecha no sea pasada
    const fechaSeleccionada = new Date(data.fecha_cita);
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    if (fechaSeleccionada < hoy) {
      nuevosErrores.fecha_cita = 'No puedes agendar en fechas pasadas';
    }

    // Validar duración si es recurrente
    const servicio = servicios.find(s => s.id == data.servicio_id);
    if (servicio && !servicio.duracion) {
      nuevosErrores.servicio_id = 'Servicio sin duración definida';
    }

    setErrores(nuevosErrores);
    return Object.keys(nuevosErrores).length === 0;
  }, []);

  // Limpiar errores
  const limpiarErrores = useCallback(() => {
    setErrores({});
  }, []);

  // Reset formulario
  const resetFormulario = useCallback(() => {
    setFormData({
      cliente_id: '',
      servicio_id: '',
      fecha_cita: format(new Date(), 'yyyy-MM-dd'),
      hora_inicio: '09:00',
      notas: ''
    });
    setErrores({});
  }, []);

  // Obtener error de un campo
  const getError = useCallback((campo) => {
    return errores[campo] || '';
  }, [errores]);

  // Tiene errores?
  const tieneErrores = useCallback(() => {
    return Object.keys(errores).length > 0;
  }, [errores]);

  return {
    formData,
    errores,
    setFormData,
    setErrores,
    validar,
    limpiarErrores,
    resetFormulario,
    getError,
    tieneErrores
  };
};
